import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import Modal from "../../layout/modal";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import "./style.css";
import { getSale, getSaleIdle, setClearSale } from "../../modules/sale/actions";
import { targetMetrick } from "../../constants/config";
import { Link } from "react-router-dom";
import history from "../../history";
import PreloaderSale from "../../components/preloader/sale";
import ContentMark from "../../components/content";

const Content = (props) => {
  const { copyPromocode, setCopyPromocode, showSale, setShowSale } = props;

  const data = useSelector((state) => state.sale.data);
  const theme = useSelector((state) => state.initData.theme);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (copyPromocode) {
      setTimeout(function () {
        setCopyPromocode(false);
      }, 5000);
    }
  }, [copyPromocode]);

  const handleClosePromocode = (e) => {
    navigate(location.pathname, { replace: true });
    setShowSale(false);
    dispatch(getSaleIdle());
  };

  const handleCopyPromocode = (e) => {
    e.preventDefault();

    if (!copyPromocode) {
      setCopyPromocode(true);
      navigator.clipboard.writeText(data.attributes.Sale_card.Promocode);

      targetMetrick(
        "Копировать промокод. Акция. " + data.attributes.Sale_card.Title_inner
      );
    }
  };

  return (
    <div className="promocode">
      {window.innerWidth < 1023 && (
        <>
        {(theme == 'dark' || theme == 'light') && (
          <button className="page__header-back" onClick={() => {
            navigate(location.pathname, { replace: true });
            setShowSale(false);
            dispatch(getSaleIdle());
          }}>
            <>
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.25 16.5L3.75 9L11.25 1.5L13.125 3.375L7.5 9L13.125 14.625L11.25 16.5Z"
                            fill="#0F0F0F"
                        />
                    </svg>
                    Назад
                </>
          </button>
        ) || (
          <button className="shop__promocode-close" onClick={() => {
            navigate(location.pathname, { replace: true });
            setShowSale(false);
            dispatch(getSaleIdle());
          }}>
              <img src="https://cdn.podeli.ru/web-catalog/assets/img/icon-close-small.svg" />
          </button>
        )}
        </>
      ) || (
        <button className="shop__promocode-close" onClick={handleClosePromocode}>
          <img src="https://cdn.podeli.ru/web-catalog/assets/img/icon-close-small.svg" />
        </button>
      )}
      {data && (
        <>
          {data.attributes.Sale_card.Title_inner && (
            <div
              className="promocode__title"
              dangerouslySetInnerHTML={{
                __html: data.attributes.Sale_card.Title_inner,
              }}
            ></div>
          )}
          {/* || (
                        <>Скидка {data.attributes.Sale_card.Percent}% по промокоду от магазина {data.attributes.Sale_card.Title}</>
                    )} */}
          {data.attributes.Sale_card.Info && (
            <div className="promocode__lead">
              <ReactMarkdown linkTarget="_blank">
                {data.attributes.Sale_card.Info}
              </ReactMarkdown>
            </div>
          )}
          {data.attributes.Sale_card.Promocode && (
            <div className="promocode__value">
              {data.attributes.Sale_card.Promocode}
              <a
                href="#"
                onClick={handleCopyPromocode}
                className="promocode__value-copy"
              >
                {(theme == 'dark' || theme == 'light') && (
                  <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                      <path
                          d="M9.99988 2C8.89531 2 7.99988 2.89543 7.99988 4H17.9999V18C19.1045 18 19.9999 17.1046 19.9999 16V4C19.9999 2.89543 19.1045 2 17.9999 2H9.99988Z"
                          fill="#86868A"
                      />
                      <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M5.99988 6C4.89531 6 3.99988 6.89543 3.99988 8V20C3.99988 21.1046 4.89531 22 5.99988 22H13.9999C15.1045 22 15.9999 21.1046 15.9999 20V8C15.9999 6.89543 15.1045 6 13.9999 6H5.99988ZM13.9999 8H5.99988V20H13.9999V8Z"
                          fill="#86868A"
                      />
                  </svg>
                ) || (
                  <img src="https://cdn.podeli.ru/web-catalog/assets/img/icon-copy.svg" />
                )}
              </a>
            </div>
          )}
          <div className="promocode__info">
            <ContentMark content={data.attributes.Sale_card.Organizator} />
          </div>
          <div className="promocode__footer">
            {data.attributes.Sale_card.Web_store && (
              <a
                href={
                  data.attributes.Sale_card.Web_store +
                  ( !data.attributes.Sale_card.Hide_web_store_utm && "?utm_source=podeli.ru&utm_medium=banner&utm_campaign=podeli_promo&openInBrowser=true" || '' )
                }
                onClick={(e) => {
                  targetMetrick(
                    data.attributes.Sale_card.Title_inner + ".Интернет-магазин"
                  );
                }}
                target="_blank"
                className="button _default"
              >
                {data.attributes.Sale_card.Web_store_title && data.attributes.Sale_card.Web_store_title || 'Интернет-магазин'}
              </a>
            )}
            {data.attributes.Sale_card.Retail_store && (
              <a
                href={data.attributes.Sale_card.Retail_store + (data.attributes.Sale_card.Retail_store.indexOf('?') < 0 && '?openInBrowser=true' || '&openInBrowser=true')}
                onClick={(e) => {
                  targetMetrick(
                    data.attributes.Sale_card.Title_inner +
                      ".Розничные магазины"
                  );
                }}
                target="_blank"
                className={`button _default ${
                  (data.attributes.Sale_card.Web_store && "_gray") || ""
                }`}
              >
                {data.attributes.Sale_card.Retail_store_title && data.attributes.Sale_card.Retail_store_title || 'Розничные магазины'}
              </a>
            )}
          </div>
        </>
      )}
    </div>
  );
};

const Sale = (props) => {
  const dispatch = useDispatch();
  const [showSale, setShowSale] = useState(false);

  const [copyPromocode, setCopyPromocode] = useState(false);

  const saleId = useSelector((state) => state.sale.id);
  const status = useSelector((state) => state.sale.status);

  useEffect(() => {
    if (status == "SUCCESS") {
      dispatch(getSaleIdle());
    }
  }, [status]);

  let location = useLocation();
  const { results } = useParams();

  /*useEffect(() => {
    const params = new URLSearchParams(location.search);
    const saleUrlId = params.get("sale");
    if (!saleUrlId) {
      setShowSale(false);
    } else {
      setShowSale(true);
    }
  }, [location]);*/

  useEffect(() => {
    if (saleId) {
      setShowSale(true);
      if (status == "IDLE") {
        dispatch(getSale(saleId));
      }
    } else {
      setShowSale(false);
    }
  }, [saleId]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const saleUrlId = params.get("sale");
    const saleId = {
      id: Number(saleUrlId),
    };
    if (saleUrlId) {
      setShowSale(true);
      dispatch(getSale(saleId));
    } else {
      setShowSale(false);
    }
  }, [history, location.search, location.hash]);

  return (
    <Modal
      show={showSale}
      toggle={setShowSale}
      load={(status == 'LOADING' && true) || false}
      loadPreview={<PreloaderSale />}
      header={
        <div
          className={`shop__promocode-alert ${
            (copyPromocode && "_show") || ""
          }`}
        >
          <span>Промокод скопирован</span>
        </div>
      }
      content={
        <Content
          copyPromocode={copyPromocode}
          setCopyPromocode={setCopyPromocode}
          showSale={showSale}
          setShowSale={setShowSale}
        />
      }
      dopClass={"_sale"}
    ></Modal>
  );
};

export default Sale;
